import { IApiMutationFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { ICertificationIssuerResource } from "../types";
import { createCertificationIssuerMutationHook } from "./createCertificationIssuerMutationHook";

export type ICertificationIssuerDeleteMutationParameters = {
    certificationIssuer: RelationalValue<ICertificationIssuerResource>;
};
export type ICertificationIssuerDeleteMutationResult = void;

export const certificationIssuerDeleteMutation: IApiMutationFunction<ICertificationIssuerDeleteMutationParameters> = ({
    certificationIssuer,
}) => ({
    method: "DELETE",
    url: `/certification_issuers/${mapRelationalValue(certificationIssuer)}`,
});

export const useCertificationIssuerDeleteMutation = createCertificationIssuerMutationHook<
    ICertificationIssuerDeleteMutationParameters,
    ICertificationIssuerDeleteMutationResult
>(certificationIssuerDeleteMutation);
